import { render, staticRenderFns } from "./Browser.vue?vue&type=template&id=7468ee4c&lang=pug&"
import script from "./Browser.vue?vue&type=script&lang=js&"
export * from "./Browser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7468ee4c', component.options)
    } else {
      api.reload('7468ee4c', component.options)
    }
    module.hot.accept("./Browser.vue?vue&type=template&id=7468ee4c&lang=pug&", function () {
      api.rerender('7468ee4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Project/editor/Browser.vue"
export default component.exports